import TextField from "../../app/TextField";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import React,{ useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Button } from "@mui/material";

const dghcn = " border-y-[3px]  border-neutral-400 font-bold text-md text-[#c7c7c7]";

export default function CurrenciesTab(props) {
    const columns = [
        {
            field: "order",
            editable: true,
            headerClassName: dghcn,
            hideable: false,
            headerName: "Order",
            width: 70,
        },
        {
            field: "code",
            editable: true,
            headerClassName: dghcn,
            hideable: false,
            headerName: "Code",
            description: "ISO Code (3 Chars)",
            width: 100,
        },
        {
            field: "name",
            editable: true,
            headerClassName: dghcn,
            hideable: false,
            headerName: "Name 1",
            width: 200,
        },
        {
            field: "name2",
            editable: true,
            headerClassName: dghcn,
            hideable: false,
            headerName: "Name 2",
            width: 200,
        },
        {
            field: "rate",
            editable: true,
            headerClassName: dghcn,
            hideable: false,
            type: "number",

            headerName: "Rate",
            width: 150,
        },
        {
            field: "symbol",
            editable: true,
            headerClassName: dghcn,
            hideable: false,
            headerName: "Symbol",
            width: 70,
        },
        {
            field: "primary",
            editable: true,
            headerClassName: dghcn,
            hideable: false,
            headerName: "Primary",
            width: 100,
        },
        {
            field: "tax_rate",
            editable: true,
            headerClassName: dghcn,
            hideable: false,
            type: "number",
            headerName: "Tax Rate",
            width: 150,
        },
        {
            field: "default_sale_price",
            editable: true,
            headerClassName: dghcn,
            discription: "Defualt Sale Price If 0 Default Page Setting Will Be Considered",
            hideable: false,
            type: "number",
            headerName: "Default Sale Price",
            width: 150,
        },
    ];
    const [selectedRow, setselectedRow] = useState({});

    const [code, setcode] = useState("");
    const [name, setname] = useState("");
    const [symbol, setsymbol] = useState("");
    const [rate, setrate] = useState("");
    return (
        <div className="h-full w-full">
            <Box sx={{ height: "20rem", width: "100%", border: 2 }}>
                <DataGrid
                sx={{ "& .MuiDataGrid-editInputCell": { color: "#c7c7c7 !important" },
                "& .MuiDataGrid-cell:focus": {
                    borderWidth: " 1px !important",
                    borderColor: "blue !important",
                    outline: "3px auto blue",
                }, "& .MuiTablePagination-root": { color: "#c7c7c7 !important" },  }}
                    rows={props.currencySettings.data}
                    columns={columns}
                    rowsPerPageOptions={[10, 100, 1000]}
                    columnHeaderHeight={45}
                    rowHeight={30}
                    showColumnVerticalBorder
                    showCellVerticalBorder
                    hideFooter
                    getRowId={(e) => {
                        return e.code;
                    }}
                    experimentalFeatures={{ newEditingApi: true }}
                    onCellEditStart={(e) => {
                        setTimeout(() => {
                            setselectedRow(e);
                        }, 100);
                    }}
                    slotProps={{
                        cell: { id: "datagridcell",className:" !border-gray-500 " },
                    }}
                    disableColumnSelector
                    getRowClassName={(e) => {
                        return "  text-[#c7c7c7]";
                    }}
                    processRowUpdate={(e) => {
                        if (e[selectedRow.field] !== selectedRow.value) {
                            editCurrency(e[selectedRow.field]);
                        }
                        return e;
                    }}
                    onProcessRowUpdateError={(e) => {
                        props.getSystemSettings();
                    }}
                    onCellKeyDown={(e, f) => {
                        // if (f.key === "Enter") {
                        //     //  quickEditHandler(e);
                        //     if (f.target.id !== "datagridcell") {
                        //         f.nativeEvent = new KeyboardEvent("keydown", { key: "Tab" });
                        //         f.key = "Tab";
                        //         f.code = "Tab";
                        //         document.activeElement.dispatchEvent(new KeyboardEvent("keydown", { key: "Tab" }));
                        //     } else if (f.target.id === "datagridcell") {
                        //         let temp = columns.filter((column) => column.show);
                        //         if (e.field === temp[temp.length - 1].field) {
                        //             let focusNum = e.id;
                        //             if (props.data.items.length === e.id) {
                        //                 focusNum = focusNum - 1;
                        //             }
                        //             props.dataTableRef.current.children[0].children[1].children[0].children[0].children[
                        //                 focusNum
                        //             ].children[1].focus();
                        //         } else {
                        //             f.nativeEvent = new KeyboardEvent("keydown", { key: "ArrowRight" });
                        //             f.key = "ArrowRight";
                        //             f.code = "ArrowRight";
                        //             document.activeElement.dispatchEvent(
                        //                 new KeyboardEvent("keydown", { key: "ArrowRight" })
                        //             );
                        //         }
                        //     }
                        //     return f;
                        // } else if (f.key === "F2") {
                        //     props.setselectedRow(e);
                        //     props.setItemCardModal(true);
                        // }
                    }}
                />
            </Box>
            <div className="m-1 ">
                <Accordion style={{ color: "#c7c7c7 !important", backgroundColor: "#5a5a5a" }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        sx={{ background: "lightgray" }}
                        style={{ color: "#c7c7c7 !important", backgroundColor: "#5a5a5a" }}
                    >
                        <div className=" font-semibold  !text-[#c7c7c7]">Create New Currency</div>
                    </AccordionSummary>
                    <AccordionDetails style={{ color: "#c7c7c7 !important", backgroundColor: "#5a5a5a" }}>
                        <div
                            className="flex flex-row items-center justify-start align-middle "
                            style={{ color: "#c7c7c7 !important" }}
                        >
                            <TextField
                                InputProps={{ sx: { color: "#c7c7c7 !important" } }}
                                InputLabelProps={{ sx: { color: "#c7c7c7 !important" } }}
                                size="small"
                                inputProps={{ className: "p-2" }}
                                label={"Code"}
                                placeholder="Code"
                                sx={{ marginX: 3 }}
                                value={code}
                                onKeyDownCapture={(e) => {
                                    if (e.key === "Enter") {
                                        document.getElementById("Name").focus();
                                    }
                                }}
                                onChange={(e) => {
                                    setcode(e.target.value);
                                }}
                                id="Code"
                            />
                            <TextField
                                InputProps={{ sx: { color: "#c7c7c7 !important" } }}
                                InputLabelProps={{ sx: { color: "#c7c7c7 !important" } }}
                                size="small"
                                inputProps={{ className: "p-2" }}
                                label={"Name1"}
                                placeholder="Name1"
                                sx={{ marginX: 3 }}
                                value={name}
                                onKeyDownCapture={(e) => {
                                    if (e.key === "Enter") {
                                        document.getElementById("Symbol").focus();
                                    }
                                }}
                                onChange={(e) => {
                                    setname(e.target.value);
                                }}
                                id="Name"
                            />
                            <TextField
                                InputProps={{ sx: { color: "#c7c7c7 !important" } }}
                                InputLabelProps={{ sx: { color: "#c7c7c7 !important" } }}
                                size="small"
                                inputProps={{ className: "p-2" }}
                                label={"Symbol"}
                                placeholder="Symbol"
                                sx={{ marginX: 3 }}
                                value={symbol}
                                onKeyDownCapture={(e) => {
                                    if (e.key === "Enter") {
                                        document.getElementById("Rate").focus();
                                    }
                                }}
                                onChange={(e) => {
                                    setsymbol(e.target.value);
                                }}
                                id="Symbol"
                            />
                            <TextField
                                InputProps={{ sx: { color: "#c7c7c7 !important" } }}
                                InputLabelProps={{ sx: { color: "#c7c7c7 !important" } }}
                                size="small"
                                inputProps={{ className: "p-2" }}
                                label={"Rate"}
                                placeholder="Rate"
                                sx={{ marginX: 3 }}
                                value={rate}
                                onKeyDownCapture={(e) => {
                                    if (e.key === "Enter") {
                                        document.getElementById("Create").focus();
                                    }
                                }}
                                onChange={(e) => {
                                    setrate(e.target.value);
                                }}
                                id="Rate"
                            />
                            <Button
                                onClick={() => {
                                    addCurrency();
                                }}
                               variant="outlined"
                                sx={{ margin: 1 }}
                                id="Create"
                            >
                                create
                            </Button>
                        </div>
                    </AccordionDetails>
                </Accordion>
            </div>
        </div>
    );
    function editCurrency(value) {
        let url = "settings/edit_currencies/";
        const cbnf = (res) => {
            if (res.data.info === "success") {
            }
        };
        let fdata = {
            code: selectedRow.row.code,
            field: selectedRow.field,
            value: value,
        };

        props.postdata(url, cbnf, fdata, false);
    }

    function addCurrency() {
        let url = "settings/add_currencies/";
        const cbnf = (res) => {
            props.getSystemSettings();
        };
        let fdata = {
            code: code,
            name: name,
            symbol: symbol,
            rate: rate,
        };

        props.postdata(url, cbnf, fdata, false);
    }
}
